module.exports = __webpack_public_path__ + "static/media/bench.946322e9.svg";